// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { ListItem, Typography } from '@mui/material';
import { IconButton } from '@shared/ui-kit/components/icon-button';
import { classNames } from '@shared/ui-kit/utils/classnames';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import styles from './bank-details-drawer-header.module.css';
import { useBankDetailsDrawerHeader } from './use-bank-details-drawer-header';

export const BankDetailsDrawerHeader = defineComponent({
  displayName: 'BankDetailsDrawerHeader',
  useSetup: useBankDetailsDrawerHeader,
  View: ({ title, description, onClose, t }) => (
    <ListItem
      component="div"
      className={classNames(styles.section, styles['section-sticky-top'])}
      disablePadding
      disableGutters
      data-testid="bank-details-drawer-header"
    >
      <header className={styles['drawer-header']}>
        <IconButton
          icon="ArrowLeft"
          variant="icon"
          color="dark"
          size="lg"
          className={styles['header-back']}
          onClick={onClose}
          aria-label={t('common.go-back', { ns: 'common' })}
          data-testid="bank-details-drawer-back"
        />

        <div className={styles['drawer-header-content']}>
          <Typography
            variant="h6"
            component="h2"
            className={styles['drawer-title']}
          >
            {title}
          </Typography>

          {description ? (
            <Typography variant="caption" className={styles['drawer-hint']}>
              {description}
            </Typography>
          ) : null}
        </div>
      </header>
    </ListItem>
  ),
});
